export const AxiosConnectionError = {
  status: 0,
  data: {
    status: 0,
    message: 'Erro de conexão.',
  },
};
